import { SelectOption } from "../../../libs/types";

import type { Dayjs } from "dayjs";

export type FormType = "add" | "edit";

export type CatalogueId =
  | "propertyAmenities"
  | "unitAmenities"
  | "parkingAmenities"
  | "pointOfInterestAmenities"
  | "viewingDaysConfig"
  | "viewingTimeSlotsConfig"
  | "feedbackQuestionnaireConfig"
  | "marketingPublicListUrl";

export type CatalogueDef = {
  id: CatalogueId;
  title: string;
  filterKey: string;
};

type WithUid = { uid: string };

export type AmenityItem = WithUid & {
  label: string;
  url?: string;
  isActive: boolean;
};

export type ViewingDayItem = WithUid & {
  label: string;
  isActive: boolean;
};

export type ViewingTimeSlotItem = WithUid & {
  startTime: string;
  endTime: string;
  isActive: boolean;
};

export type FeedbackQuestionItem = WithUid & {
  label: string;
  order: number;
  isActive: boolean;
};

export type MarketingConfigurationItem =
  | AmenityItem
  | ViewingDayItem
  | ViewingTimeSlotItem
  | FeedbackQuestionItem;

export type MarketingConfigurationPayload =
  | Omit<AmenityItem, "uid">
  | Omit<ViewingDayItem, "uid">
  | Omit<ViewingTimeSlotItem, "uid">
  | Omit<FeedbackQuestionItem, "uid">;

export type MarketingConfigurationFormData = {
  organization: SelectOption | null;
  label: string;
  startTime: Dayjs | null;
  endTime: Dayjs | null;
  order: number | null;
  url: string;
  isActive: boolean;
};

export type OrgMarketingConfigurationData = {
  propertyAmenities: AmenityItem[];
  unitAmenities: AmenityItem[];
  parkingAmenities: AmenityItem[];
  pointOfInterestAmenities: AmenityItem[];
  viewingDaysConfig: ViewingDayItem[];
  viewingTimeSlots: ViewingTimeSlotItem[];
  feedbackQuestionnaireConfig: FeedbackQuestionItem[];
};

export const AMENITY_CATALOGUE_IDS: CatalogueId[] = [
  "propertyAmenities",
  "unitAmenities",
  "parkingAmenities",
  "pointOfInterestAmenities",
];

export function isAmenityCatalogue(catalogueId: CatalogueId): boolean {
  return AMENITY_CATALOGUE_IDS.indexOf(catalogueId) !== -1;
}

export const ICON_UPLOAD_CATALOGUE_IDS: CatalogueId[] = [
  "propertyAmenities",
  "unitAmenities",
  "pointOfInterestAmenities",
];

export function isIconUploadCatalogue(catalogueId: CatalogueId): boolean {
  return ICON_UPLOAD_CATALOGUE_IDS.indexOf(catalogueId) !== -1;
}
